import * as Config from '../../../config';
import React from 'react';
import './LeftBarContainer.css';

import IconArrow from './svg/IconArrow';

function InformationSection() {
  const redirect = () => { window.open(Config.REDIRECT_TRIAL, `_blank`) }
  return (
    <div className={'flexColumn space-between infos-section'}>
      <span className={'type-medium fz14'}>Enable full track-playback in high quality audio and more.</span>
      <div className={`cta type-medium fz11`} onClick={redirect}>
        Try {Config.capAppName()} Streaming for free
        <IconArrow /> 
      </div>
    </div>
  )
}

export default InformationSection;
